import confetti from "canvas-confetti";

const COLORS = ["#d7262c", "#F59E0B", "#059669", "#1f5a4c", "#FDE68A"];

export function celebrate(big = false) {
  confetti({
    particleCount: big ? 160 : 60,
    spread: big ? 100 : 70,
    origin: { y: 0.6 },
    colors: COLORS,
    scalar: big ? 1.1 : 0.9,
  });
  if (big) {
    setTimeout(() => confetti({ particleCount: 80, angle: 60, spread: 60, origin: { x: 0 }, colors: COLORS }), 250);
    setTimeout(() => confetti({ particleCount: 80, angle: 120, spread: 60, origin: { x: 1 }, colors: COLORS }), 250);
  }
}
